<template>
    <div class="timeLine" v-if="timeLineShow">
        <div class="timeBox">
            <div><img :src="prevImg" alt="" @click="prevOrNext('prev')"></div>
            <div class="boxLine">
                <div class="times" v-for="(value, index) in timesData.info.times" :key="index">
                    <div @click="timeChange(value, index)">
                        <img :src="timeBtn" alt="" class="timeBtn" v-if="activeIndex != index">
                        <img :src="activeBtn" alt="" class="timeBtn" v-else>
                        <span v-html="getValue(value)" :class="[activeIndex == index ? 'activeSpan' : '']"></span>
                    </div>
                </div>
            </div>
            <div><img :src="nextImg" alt="" @click="prevOrNext('next')"></div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data(){
        return {
            prevImg: require('@/assets/default/img/timeLine/sgz_icon_l.png'),
            nextImg: require('@/assets/default/img/timeLine/sgz_icon_r.png'),
            timeBtn: require('@/assets/default/img/timeLine/sgz_y.png'),
            activeBtn: require('@/assets/default/img/timeLine/sgz_xz.png'),
            activeIndex: 0
        }
    },
    computed:{
        ...mapState('thematic', {
            timeLineShow: 'timeLineShow',
            timesData: 'timesData'
        }),
        getValue(){
            return function(value){
                let val = value.split(' ')[0]
                return val
            }
        }
    },
    watch:{
        timesData(newV){
            if(newV){
                let time = newV.info.time
                let index = newV.info.times.findIndex(item => item == time)
                // this.activeIndex = newV.info.times.length - 1
                this.activeIndex = index
            }
        }
    },
    methods:{
        timeChange(value, index){
            this.activeIndex = index
            EVENTHUB.fire('changeVWMTSTime', this.activeIndex)
        },
        prevOrNext(type){
            let i = this.activeIndex

            if(type == 'prev'){
                i-= 1
            }else{
                i+= 1
            }
            let len = this.timesData.info.times.length

            if(i < 0){
                i = len - 1
            }

            if(i == len){
                i = 0
            }

            this.activeIndex = i
            EVENTHUB.fire('changeVWMTSTime', this.activeIndex)
        }
    }
}
</script>
<style lang="less">
.timeLine{
    display: flex;
    width: 100%;
    justify-content: center;
    position: absolute;
    bottom: 15px;
    .timeBox{
        background: #fff;
        padding: 0 10px 10px 10px;
        height: 60px;
        display: flex;
        flex-direction: row;
        align-items: center;
        div{
            flex: 1;
            text-align: center;
            img{
                margin-top: 2px;
                cursor: pointer;
            }
        }
        .boxLine{
            margin: 0 10px;
            flex: 7;
            height: 10px;
            border-radius: 10px;
            background: #AAC5EE;
            display: flex;
            flex-direction: row;
            align-items: center;
            .times{
                flex: 1;
                margin: 0 30px;
                cursor: pointer;
                .timeBtn{
                    position: relative;
                    top: 12px;
                }
                span{
                    position: relative;
                    top: 8px;
                    font-size: 14px;
                    width: 85px;
                    display: block;
                }
                .activeSpan{
                    color: rgb(47, 134, 255);
                    font-weight: bold;
                }
            }
        }
    }
}
</style>